import axios from 'axios'
//baseURL 直接写死为 /api/portal，开发和生产环境都用这个相对路径
const service = axios.create({
  baseURL: '/api/portal',
  timeout: 10000    // （10 秒超时）
})

service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code !== 200) {
      return Promise.reject(new Error(res.message || 'Error'))
    }
    return res
  },
  error => {
    console.error(error)
    return Promise.reject(error)
  }
)

export default service
